import { useEffect, useState } from 'react'
import { Room, PresenceMember } from '@ably/chat'

export function usePresence(room: Room | null) {
  const [members, setMembers] = useState<PresenceMember[]>([])
  const [isOtherUserOnline, setIsOtherUserOnline] = useState(false)

  useEffect(() => {
    if (!room) return

    const { unsubscribe } = room.presence.subscribe((event) => {
      setMembers(event.members)
      setIsOtherUserOnline(event.members.length > 1) // More than just current user
    })

    // Enter presence
    room.presence.enter({ status: 'online' })

    return () => {
      room.presence.leave()
      unsubscribe()
    }
  }, [room])

  return {
    members,
    isOtherUserOnline,
    onlineCount: members.length
  }
}